import { Component } from "@theme/component";
import { debounce } from "@theme/utilities";

class CardLayered extends Component {
  /** @type {string[]} */
  requiredRefs = ["cardLayeredButton", "cardLayeredContent"];

  /** @type {AbortController | null} */
  #abortController = null;

  constructor() {
    super();

    this.classes = {
      isOpen: "open",
    };
  }

  connectedCallback() {
    super.connectedCallback();

    // A fresh controller on every connect: the previous one was aborted when the element was removed.
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.init(signal);
    window.addEventListener("resize", this.#handleResize, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
    this.#handleResize.cancel();
  }

  /**
   * @param {AbortSignal} signal
   */
  init(signal) {
    this.close();

    if (Shopify.designMode) {
      document.addEventListener(
        "shopify:block:select",
        (e) => {
          if (this.contains(e.target) && e.target.closest(".card-layered__description")) {
            this.open();
          } else {
            this.close();
          }
        },
        { signal }
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    this.toggle();
  }

  toggle() {
    if (this.classList.contains(this.classes.isOpen)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    const { cardLayeredButton: button } = this.refs;

    this.classList.add(this.classes.isOpen);
    button.setAttribute("aria-expanded", "true");
    this.updateContentHeight();
  }

  close() {
    const { cardLayeredContent: content, cardLayeredButton: button } = this.refs;

    this.classList.remove(this.classes.isOpen);
    button.setAttribute("aria-expanded", "false");
    content.style.maxHeight = "0";
  }

  updateContentHeight() {
    const { cardLayeredContent: content } = this.refs;

    if (this.classList.contains(this.classes.isOpen)) {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }

  #handleResize = debounce(() => this.updateContentHeight(), 150);
}

if (!customElements.get("card-layered")) {
  customElements.define("card-layered", CardLayered);
}
